<template>
  <div v-if="qrCodeInfo.bindGuide" class="bindcard">
    <div class="bindcard-title">
      {{ qrCodeInfo.bindGuide.title }}
    </div>
    <!-- eslint-disable-next-line -->
    <div class="bindcard-tip" v-html="formattedHint"></div>
    <div v-if="qrCodeInfo.bindGuide.promotion" class="bindcard-promotion">
      {{ qrCodeInfo.bindGuide.promotion }}
    </div>
    <div class="bindcard-button" @click="goToBind()">
      <span>{{ qrCodeInfo.bindGuide.btnTitle }}</span>
    </div>
    <div class="bindcard-split">
      <div class="bindcard-split-line"></div>
    </div>
    <div v-if="bankList" class="bindcard-cardlist">
      <div class="bindcard-cardlist-tip">
        {{ bindcardCardlistTip }}
      </div>
      <div class="bindcard-cardlist-list">
        <div
          v-for="(item, index) in bankList"
          :key="index"
          class="bindcard-cardlist-list-item"
          @click="fastBind(item)"
        >
          <div class="bindcard-cardlist-list-item-left">
            <img
              class="bindcard-cardlist-list-item-left-icon"
              :src="item.icon"
            />
            <div class="bindcard-cardlist-list-item-left-text">
              {{ item.name }}
            </div>
          </div>
          <div class="bindcard-cardlist-list-item-arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUrlParam } from '@mx/acquiring-utils';

export default {
  name: 'BindCard',
  components: {},
  props: {
    qrCodeInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formattedHint() {
      return this.qrCodeInfo?.bindGuide?.hint.replace('\n', '<br>')
    },
    bindcardCardlistTip() {
      return this.qrCodeInfo?.bindGuide?.quickBindEntry?.info?.tip
    },
    bankList() {
      return this.qrCodeInfo?.bindGuide?.quickBindEntry?.banklist
    },
    status() {
      return getUrlParam('type') === 'scan' ? 2 : 1
    },
  },
  created() {},
  mounted() {
    this.$lx.bindCardPV({ custom: { status: this.status } })
    if (this.qrCodeInfo?.bindGuide?.promotion) {
      this.$lx.promotionMV({
        status: this.status,
        promotion:
          this.qrCodeInfo?.bindGuide?.promotion?.promotionDetails || [],
      })
    }
    this.bankList &&
      this.bankList.forEach((p) => {
        this.$lx.bindCardMV({
          bank_name: p.name,
          status: this.status,
        })
      })
  },
  methods: {
    goToBind() {
      this.$lx.bindBtnMC({ status: this.status })
      this.$bridge.openPage(this.qrCodeInfo.bindGuide.btnUrl)
    },
    fastBind(item) {
      this.$lx.bindCardMC({
        bank_name: item.name,
        status: this.status,
      })
      this.$bridge.openPage(item.protocolSign.url)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.bindcard {
  .flex-column-center();
  width: 345px;
  background: #ffffff;
  margin: 10px auto 23px;
  border-radius: 9px;
  padding: 0 20px 10px;
  &-title {
    .font-area(24px);
    margin-top: 50px;
    font-family: PingFangSC-Semibold;
    color: #222222;
    letter-spacing: 0;
  }
  &-tip {
    margin-top: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #222222;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
  }
  &-promotion {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #ff411a;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
    margin-top: 30px;
    margin: 30px 0 -25px;
  }
  &-button {
    .flex-center(center);
    width: 150px;
    height: 45px;
    margin-top: 40px;
    background: #ffd100;
    border-radius: 6px;
    > span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #222222;
      letter-spacing: 0;
      line-height: 20px;
    }
  }
  &-split {
    margin-top: 60px;
    width: 100%;
    height: 1px;
    position: relative;
    transform: scaleY(0.5);
    &-line {
      position: absolute;
      width: 100%;
      height: 1px;
      background-image: linear-gradient(
        to right,
        #e5e5e5 0%,
        #e5e5e5 80%,
        transparent 50%
      );
      background-size: 8px 100%;
      background-repeat: repeat-x;
    }
  }
  &-cardlist {
    margin-top: 60px;
    width: 100%;
    &-tip {
      .font-area(12px);
      font-family: PingFangSC-Regular;
      color: #222222;
    }
    &-list {
      .flex-column-center();
      margin-top: 10px;
      &-item {
        .flex-center(space-between);
        height: 56px;
        width: 100%;
        margin-bottom: 10px;
        position: relative;
        &-left {
          .flex-center(flex-start);
          width: 100%;
          &-icon {
            .size(18px);
            margin-left: 15px;
          }
          &-text {
            .font-area(14px);
            margin-left: 8px;
            font-family: PingFangSC-Semibold;
            color: #333333;
          }
        }
        &-arrow {
          margin-right: 20px;
          width: 4.5px;
          height: 8px;
          .bg-img(
            url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAK1JREFUKBWNkb0NwyAQhTk8gKtkAegygitnA0+aKm1cZQOnYwNXnoC8hyJ0xMj4pJP4+e549xDn3NMY04vIFEJYsa6GxWkfYxyQs/f+UqVwaNkJuQC8HcHCDuxEiDCKPsjxX0YCz8AZbMEFeARz6iJ+2u7USs3IB4EdWFSpzQ7EB1xx/1IOTOQ7VZRswn5WULYpD9PyMoEtiK/KGYig5fg1TbzUwak3ePau/a8Gv6NalBqnbXK0AAAAAElFTkSuQmCC)
          );
        }
      }
      &-item::before {
        .half-px();
        border: 1px solid #e5e5e5;
        border-radius: 12px;
      }
    }
  }
}
</style>
